export function projectPublishing(project) {
  if (!project || !project.publishing) return '';
  let text = '';
  let i = 0;
  project.publishing.forEach(publish => {
    if (i === project.publishing.length - 1 && i !== 0) {
      text += ' and ';
    } else if (text.length !== 0) {
      text += ', ';
    }
    text += publish.publishing;
    i++;
  });
  return text;
}
